import React from 'react';
import 'react-modal-video/css/modal-video.min.css';
import '../assets/css/animate.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/font-awesome.min.css';
import '../assets/plugins/dimon-icons/style.css';
import '../assets/css/style.css';
import '../assets/css/responsive.css';
import Footer from '../components/Footer';
import Subscribe from '../components/Subscribe';
import NavTwo from './NavTwo';

const Layout = (props) => {
  return (
    <div>
      <NavTwo />
      <div className='page-wrapper'>{props.children}</div>
      <Subscribe />
      <Footer />
    </div>
  );
};
export default Layout;
